import React from "react";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { formatUnixTime } from "../../../utilities/commonFunctions/timeConversionFunctions";

const IpsDeficiencyTable = ({ data, handleShow, setItem, activeList }) => {
  let columns = [
    {
      Header: "Code",
      accessor: "typeCode",
      width: 75
    },
    {
      Header: "Description",
      accessor: "typeDesc",
      width: 255
    },
    {
      Header: "Points",
      accessor: "ipsPoints",
      width: 75
    },
    {
      Header: "Rule Name",
      accessor: "ruleName"
    },
    {
      Header: "Severity",
      accessor: "severity",
      width: 75
    },
    {
      Header: "Last Updated",
      //accessor: "lastUpdateDate",
      accessor: (row) => {
        let time = formatUnixTime(row.lastUpdateDate);
        return time.toLocaleDateString() + " by " + row.lastUpdateUser;
      }
    },
    /*Cell: (row) => {
        let time = formatUnixTime(row.lastUpdateDate);
        return time.toLocaleDateString() + " by " + row.lastUpdateUser;
      }
    },*/
    {
      Header: "",
      accessor: "edit",
      Cell: (row) => (
        <div className='d-flex flex-column align-items-center'>
          <span
            className='mt-2 hyperlink'
            onClick={() => {
              handleShow("Edit");
              setItem(row.row.original);
            }}
          >
            Edit
          </span>
          {!activeList.some((item) => item.typeCode === row.row.original.typeCode) && !row.row.original.deactivated && (
            <span
              className='mb-2 hyperlink'
              onClick={() => {
                handleShow("Deactivate");
                setItem(row.row.original);
              }}
            >
              Deactivate
            </span>
          )}
          {!!row.row.original.deactivated && (
            <span
              className='mb-2 hyperlink'
              onClick={() => {
                handleShow("Activate");
                setItem(row.row.original);
              }}
            >
              Reactivate
            </span>
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <DtsReactTable
        data={data}
        columns={columns}
        headerColor='ddw'
        rowOnClick={true}
        rowClickHandler={setItem}
        showGlobalFilter
      />
    </>
  );
};

export default IpsDeficiencyTable;
